import { CreateNewProjectDialogComponent } from './create-new-project-dialog/create-new-project-dialog.component';
import { CreateNewArticleDialogComponent } from './create-new-article-dialog/create-new-article-dialog.component';

export { CreateNewProjectDialogComponent, CreateNewArticleDialogComponent };

export default [
  CreateNewProjectDialogComponent,
  CreateNewArticleDialogComponent
];
